import orderingApi from "../../api/ordering/OrderApi";
import OrderGrid from "../../components/Orders/OrderGrid";
import OrderList from "../../components/Orders/OrderList";
import Layout from "../../Layout";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import Loading from "../../Util/Loading";
import {
  LayoutGrid,
  List,
  CalendarDays,
  CalendarRange,
  Layers,
} from "lucide-react";

const Ordering = () => {
  const [ordering, setOrdering] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [view, setView] = useState("grid"); // grid | list
  const [filter, setFilter] = useState("today"); // today | week | all
  console.log({ ordering });

  const getAllOrdering = async () => {
    try {
      const { response } = await orderingApi.getAllOrders();
      if (response && response.data) {
        setOrdering(response.data.orders);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching bookings:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await getAllOrdering();

      setIsLoading(false);
    };
    fetchData();
  }, []);

  const getOrderStatus = (order) => {
    const created = new Date(order.createdAt);
    const now = new Date();
    const diffHours = (now - created) / (1000 * 60 * 60);

    if (diffHours > 24 && order.orderStatus !== "cancelled") {
      return "completed";
    }
    return order.orderStatus;
  };

  const refreshDataFast = async () => {
    await getAllOrdering();
  };

  // Auto refresh for hold times (every 1 minute)
  useEffect(() => {
    console.log("♻️ Auto-refresh: hold times every 1 minute");

    const interval = setInterval(
      () => {
        refreshDataFast();
      },
      1 * 30 * 1000,
    ); // 0.5 minute

    return () => clearInterval(interval);
  }, []);

  const filteredOrders = React.useMemo(() => {
    const now = new Date();

    return ordering.filter((order) => {
      const created = new Date(order.createdAt);

      if (filter === "today") {
        return (
          created.getDate() === now.getDate() &&
          created.getMonth() === now.getMonth() &&
          created.getFullYear() === now.getFullYear()
        );
      }

      if (filter === "week") {
        const diffDays = (now - created) / (1000 * 60 * 60 * 24);
        return diffDays <= 7;
      }

      return true; // all
    });
  }, [ordering, filter]);
  return (
    <Layout>
      <div className="p-2 lg:p-6 bg-dry min-h-screen">
        {/* HEADER */}

        <div className="mb-4">
          {/* TITLE ROW */}
          <div className="flex items-center justify-between mb-3">
            <h1 className="text-xl font-semibold text-gray-800 uppercase tracking-widest text-neonYellow animate-neonFlicker ">
              Orders
            </h1>

            {/* optional count */}
            <span className="text-sm text-gray-400">
              {ordering?.length || 0}
            </span>
          </div>

          {/* CONTROLS ROW */}
          <div className="flex items-center justify-between gap-3">
            {/* FILTER GROUP */}
            <div className="flex bg-gray-100 rounded-xl p-1">
              {[
                { key: "today", icon: CalendarDays },
                { key: "week", icon: CalendarRange },
                { key: "all", icon: Layers },
              ].map(({ key, icon: Icon }) => (
                <button
                  key={key}
                  onClick={() => setFilter(key)}
                  className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
                    filter === key
                      ? "bg-navy text-yellowstar shadow"
                      : "text-gray-500 hover:bg-gray-200"
                  }`}
                >
                  <Icon size={16} />
                </button>
              ))}
            </div>

            {/* VIEW GROUP */}
            <div className="flex bg-gray-100 rounded-xl p-1">
              <button
                onClick={() => setView("grid")}
                className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
                  view === "grid"
                    ? "bg-navy text-yellowstar shadow"
                    : "text-gray-500 hover:bg-gray-200"
                }`}
              >
                <LayoutGrid size={16} />
              </button>

              <button
                onClick={() => setView("list")}
                className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
                  view === "list"
                    ? "bg-navy text-yellowstar shadow"
                    : "text-gray-500 hover:bg-gray-200"
                }`}
              >
                <List size={16} />
              </button>
            </div>
          </div>
        </div>

        {/* CONTENT */}
        {isLoading ? (
          <Loading />
        ) : view === "grid" ? (
          <OrderGrid
            ordering={filteredOrders}
            getOrderStatus={getOrderStatus}
          />
        ) : (
          <OrderList
            ordering={filteredOrders}
            getOrderStatus={getOrderStatus}
          />
        )}
      </div>
    </Layout>
  );
};

export default Ordering;
